<template>
  <div v-if="showShare" class="share-box" @click="shareHandle()">
    <img class="" src="https://coolcdn.igetcool.com/p/2023/9/4e65e5fe7b0c7e19d547ed574a146766.png?_80x80.png" alt="">
  </div>
</template>

<script>
import { getUser } from '@utils/auth';
import { env, JS2Native } from '@utils';

export default {
  props: {

    goodsDetail: {
      type: Object
    },
    shareData: {
      type: Object
    },
    userReallyOnline: Boolean,
    isShowShare: {
      type: [Boolean, Number],
      default() {
        return true;
      }
    },
  },
  data() {
    let {
      itemid,
      igc_from,
      ptFlag
    } = this.$route.query;
    if (igc_from === 'xxx') { igc_from = undefined }

    return {
      itemid,
      unfold: false,
      contentWidth: null,
      unfoldTimeOutMark: null,
      timeOutMark: null,
      userInfo: null,
      igc_from,
      ptFlag,
      showCustomerService: true,
    };
  },
  computed: {
    showShare() {
      return env.isApp && this.isShowShare && !env.isHarmonyApp;
    }
  },
  methods: {
    shareHandle() {
      let uid = null;
      let data = getUser();
      if (data) {
        uid = JSON.parse(data).uid;
      }

      // 有反馈在app分享出来的地址是http的，不易复现，将协议头写死
      const locationOrigin = 'https://' + window.location.host;
      const igcFrom = this.igc_from ? `&igc_from=${this.igc_from}` : '';

      const goodsMsg = this.goodsDetail;
      let shareMsg;
      if (this.shareData?.shareTitle) {
        shareMsg = {
          title: this.shareData.shareTitle,
          coverImg: this.shareData.shareCover,
          intro: this.shareData.shareIntro,
          url: this.shareData.shareUrl,
        };
      } else {
        shareMsg = {
          title: goodsMsg.basicAndGuideShareResDTO
            ? goodsMsg.basicAndGuideShareResDTO.shareTitle
            : `分享|${goodsMsg.name}`,
          coverImg: goodsMsg.basicAndGuideShareResDTO
            ? goodsMsg.basicAndGuideShareResDTO.shareImageUrl
            : goodsMsg.coverImg,
          intro: goodsMsg.basicAndGuideShareResDTO
            ? goodsMsg.basicAndGuideShareResDTO.shareDescribe
            : '限时特惠，即将开课，戳此立抢>>',
          url: `${locationOrigin}${location.pathname}?itemid=${this.itemid}${igcFrom}${
            (this.goodsDetail.sellType === 4 || !uid) ? '' : '&instructor=' + uid
          }`
        };
      }
      JS2Native({
        name: 'webShare',
        params: {

          // 新版才有用
          shareType: 0,

          // 新版才有用
          showWindow: 0,
          channel: ['WXFRIEND', 'WXPYQ'],
          shareInfo: {
            shareTitle: shareMsg.title,
            shareCover: shareMsg.coverImg,
            shareIntro: shareMsg.intro,
            shareUrl: shareMsg.url,
            hostAndPath: location.origin + location.pathname
          },
          event: 'sndd_app_traffic'
        }
      });
    },

  }
};
</script>

<style lang="stylus" scoped>
  *
    box-sizing border-box
  .share-box {
    width 40px;
    height 40px;
    position fixed;
    right: 20px;
    top: 40px;
    z-index: 10;
  }

  .share-box img {
    width 100%;
    height 100%;
  }

  .main
    position fixed
    display flex
    align-items center
    right 0
    top 60px
    height .56rem
    padding 0 .04rem 0 .12rem
    background-color rgba(0, 0, 0, .4)
    border-radius 1rem 0 0 1rem
    transition width .5s
    -webkit-transition width .5s
    z-index 2000
    .block
      display flex
      flex-direction row
      align-items center

      &:not(:first-child)
        margin-left .12rem

      &.left_over
        &:not(:first-child)
          margin-left -.05rem !important

      .icon
        box-sizing border-box
        display inline-block
        width 24px
        height 24px
        background-size 16px 16px
        background-position center
        background-repeat no-repeat
        padding 6px
        border-radius 12px
        background-color white

        &.share
          background-image image-set(url(./images/mall_share_icon.png) 1x, url(./images/mall_share_icon@2x.png) 2x)
          background-image -webkit-image-set(url(./images/mall_share_icon.png) 1x, url(./images/mall_share_icon@2x.png) 2x)

        &.list
          background-image image-set(url(./images/h5_payment_icon_my_order.png) 1x, url(./images/h5_payment_icon_my_order@2x.png) 2x)
          background-image -webkit-image-set(url(./images/h5_payment_icon_my_order.png) 1x, url(./images/h5_payment_icon_my_order@2x.png) 2x)

        &.im
          background-image image-set(url(../../assets/images/icon/my_im_icon.png) 1x, url(../../assets/images/icon/my_im_icon@2x.png) 2x)
          background-image -webkit-image-set(url(../../assets/images/icon/my_im_icon.png) 1x, url(../../assets/images/icon/my_im_icon@2x.png) 2x)

      .name
        font-size 12px
        font-weight 500
        line-height 14px
        color white
        margin-left .1rem
</style>
